"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGridVariables = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stylesUtils = require("../../utils/stylesUtils");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getGridVariables = function getGridVariables(mediaQueries) {
  return {
    variable: _constants.GRID_SPACING_CSS_VARIABLE_NAME,
    value: (0, _stylesUtils.px)(_constants.GRID_SPACING.xl),
    mediaQueries: _objectSpread(_objectSpread(_objectSpread({}, mediaQueries.lg({
      ':root': (0, _defineProperty2.default)({}, _constants.GRID_SPACING_CSS_VARIABLE_NAME, (0, _stylesUtils.px)(_constants.GRID_SPACING.lg))
    })), mediaQueries.md({
      ':root': (0, _defineProperty2.default)({}, _constants.GRID_SPACING_CSS_VARIABLE_NAME, (0, _stylesUtils.px)(_constants.GRID_SPACING.md))
    })), mediaQueries.sm({
      ':root': (0, _defineProperty2.default)({}, _constants.GRID_SPACING_CSS_VARIABLE_NAME, (0, _stylesUtils.px)(_constants.GRID_SPACING.sm))
    }))
  };
};

exports.getGridVariables = getGridVariables;